import React from 'react';

const ContactButton = props => {
  const text = 'お問い合わせ';
  return (
    <div
      style={{...props.style}}
      className="ContactButtonContainer"
    >
      <div
        className="BoxShadow ContactButton"
        onClick={props.onClick}
      >
        {text}
      </div>
    </div>
  );
};


export default ContactButton;
